<div fxLayout="row wrap" fxLayout.xs="column wrap" style="justify-content: space-between;">
	<div style="margin: 0 !important; width: 100%;" class="pdt-50">
			<h5>{{ 'sprint9.cockpit.card.all.diagramm' | translate }}</h5>
			<h6>{{ 'sprint9.cockpit.card.all.ansichteinstellung' | translate }}</h6>

			<div style="display: flex; justify-content: start; flex-direction: row;">
				<div>
					<mat-button-toggle-group #btngroupVaeDurschnitt="matButtonToggleGroup" appearance="standard"
						id="btnTogglegroupVaeDurschnitt" name="btnTogglegroupVaeDurschnitt" [value]="vae"
						aria-label="anzhal or Anteil">
					<mat-button-toggle value="{{vae}}" (change)="selectionDurschnittOrVaeChanged($event)">
						 <small>{{ 'i18n.cockpit.card.chart.personalbestand.vae.anzahl' | translate}}</small>
					</mat-button-toggle>

					<mat-button-toggle value="{{durschnitt}}" (change)="selectionDurschnittOrVaeChanged($event)">
						 <small>{{ 'i18n.cockpit.card.chart.personalbestand.durschnitt' | translate}}</small>
					</mat-button-toggle>
					</mat-button-toggle-group>
				</div>
			</div>

			<div id="svgContainerChartDurchschnittlicherGeschaeftigungsgrad" class="cockpit-svg-image"></div>
	</div>
</div>
